import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../../libs'
import { RejectExchangerTransfer, RejectExchangerTransferForm } from './types'
import qs from 'qs'

export const setReject = createEvent<RejectExchangerTransferForm>()
export const $reject = restore<RejectExchangerTransferForm>(setReject, {
  rejectReason: '',
  inputs: '',
})

// submit reject

export const submitReject = createEvent<RejectExchangerTransfer>()

export const rejectExchangerTransferRequest = fx<RejectExchangerTransfer, void>(
  {
    method: 'PUT',
    url: `/exchanger_transfer/`,
  },
)

sample({
  clock: submitReject,
  fn: ({ requestId, rejectReason }) => {
    return {
      body: {
        requestId: requestId,
        status: 'STATUS_REJECTED',
        rejectReason: rejectReason,
      },
      url: `/exchanger_transfer/${requestId}?${qs.stringify({
        populate: `["ExchangerTransfer.client", "ExchangerTransfer.exchanger", "ExchangerTransfer.account", "Exchanger.owner"]`,
      })}`,
    }
  },
  target: rejectExchangerTransferRequest,
})
